import axios from 'axios';
import { API_URL, TOKEN_KEY } from '../config';

export const api = axios.create({ baseURL: API_URL });

// Cliente axios SEM token nem interceptor de 401 — para rotas publicas
// (ex.: /pix?payload=) que sao acessadas por clientes sem login. Usar `api`
// nessas rotas faria 401 redirecionar pra /login indevidamente.
export const apiPublica = axios.create({ baseURL: API_URL });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && !err.config?.url?.includes('/auth/login')) {
      localStorage.removeItem(TOKEN_KEY);
      if (!window.location.pathname.startsWith('/login')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);
